var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"faq-content-all"},[_c('h1',[_vm._v("FAQ's")]),_vm._l((_vm.qs),function(ref,i){
var q = ref.q;
var a = ref.a;
return _c('div',{key:i,staticClass:"single-faq-list"},[_c('h4',[_vm._v(_vm._s(q))]),_c('p',[_vm._v(_vm._s(a))])])})],2),_c('div',{staticClass:"disposals"},[_c('h1',[_vm._v("Disposal")]),_vm._l((_vm.disposals),function(ref,i){
var h = ref.h;
var v = ref.v;
return _c('div',{key:i,staticClass:"sigle-dsp"},[_c('h2',[_vm._v(_vm._s(h))]),_c('p',[_vm._v(_vm._s(v))])])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }